<template>
  <div class="mx-3">
    <div>
      <ValidationObserver ref="messageObserver">
        <div class="additional-container">
          <div class="py-3 px-1 pl-c-xl">
            <icon-view
              icon="fas fa-info-circle"
              icon-background="transparent"
              icon-color="#FF7058"
              icon-size="1.0625rem"
              :title="sectionTitle"
              variant="custom-icon"
            />
          </div>
        </div>
        <div v-if="!isReadOnly">
          <span class="my-3 color-gray-6 font-16 text-justify">
            Seleccione Municipio(s):
          </span>
        </div>
        <div v-if="!isReadOnly" class="mt-3">
          <span class="my-3 color-gray-6 font-16 text-justify">
            <i class="fas fa-exclamation-circle" />
            Lugares en que ofrecerá los servicios, puede seleccionar más de uno.
          </span>
        </div>
        <div v-if="!isReadOnly" class="row mt-3">
          <div class="col-3 py-3 px-1">
            <validation-provider
              v-slot="{ errors }"
              name="customDropDownState"
              rules="required"
            >
              <custom-drop-down
                id="state"
                v-model="model.state"
                :clearable="false"
                custom-error-msg="Favor seleccionar al menos un Municipio."
                :error="errors[0]"
                fieldkey="id"
                fieldname="name"
                :options="availablestateOptions"
                placeholder="Seleccione"
              />
            </validation-provider>
          </div>
          <div class="col-9 py-3 px-1">
            <action-button
              id="btnAdd"
              i="fas fa-file-plus fa-lg"
              text="Añadir"
              variant="success"
              @click="onAddHandler"
            />
          </div>
        </div>
        <div class="mt-3 py-3 px-1">
          <span class="my-3 color-gray-6 font-16 text-justify">
            Áreas Geográficas Seleccionadas:
          </span>
          <div>
            <div
              v-for="(item, index) in selectedState"
              :key="`reason-item-${index}`"
              class="reason-item px-3 py-1 d-inline-block mr-2 my-2"
              :class="{ 'bg-white': isReadOnly }"
            >
              <span class="color-black font-16 font-weight-bold">
                {{ item.name }}
              </span>
              <i
                v-if="!isReadOnly"
                class="far fa-times-circle text-red font-16 cursor-pointer ml-2"
                @click="onDeleteItemHandler(index)"
              />
            </div>
          </div>
        </div>
        <div v-if="isReadOnly" class="col-12">
          <hr />
        </div>
        <div class="mt-3 mb-3 align-items-center d-flex justify-content-end">
          <action-button
            v-if="!isReadOnly"
            id="btnCancel"
            :disabled="isReadOnly"
            i="fas fa-times-circle"
            text="Cancelar"
            variant="outline-danger mr-3 pl-3 pr-4"
            @click="onCancel"
          />
          <action-button
            v-if="!isReadOnly"
            id="btnSave"
            i="fas fa-flag pr-2"
            text="Someter"
            variant="success px-3"
            @click="onSaveHandler"
          />
        </div>
        <div class="col-12">
          <custom-modal
            cancel-text="Cancelar"
            icon="fas fa-exclamation-circle"
            is-centered
            :save-icon="'fas fa-flag pr-2'"
            save-text="Someter"
            show-cancel
            show-save
            title="Someter"
            :value="showModal"
            width="850px"
            @cancel="onCancelAcceptTermHandler"
            @save="onSubmit"
          >
            <custom-checkbox-single-option
              id="custom-checkbox-acceptedTerms"
              v-model="acceptedTerms"
              class="font-16"
              option-text="Acepto los términos y responsabilidades"
              title="Certifico que la información ofrecida es cierta y correcta"
            />
          </custom-modal>
        </div>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import IconView from 'icon-view';
import { getStaticInformation as _getStaticInformation } from '@/services/provider/provider-question.js';
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import CustomDropDown from 'custom-drop-down';
import ActionButton from 'ActionButton';
import providerProfileStates from '@/utils/constants/ProviderProfileStates';
import { submitGeographicArea as _submitGeographicArea } from '@/services/provider/provider-question.js';
import providerQuestionSection from '@/utils/constants/providerQuestionSection';
import CustomModal from 'CustomModal';
import CustomCheckboxSingleOption from 'custom-checkbox-single-option';

export default {
  name: 'GeographicAreas',
  components: {
    IconView,
    ValidationObserver,
    ValidationProvider,
    CustomDropDown,
    ActionButton,
    CustomModal,
    CustomCheckboxSingleOption,
  },
  mixins: [alertMixin],
  async mounted() {
    await this.getState();
    await this.getMunicipality();
  },
  data: () => ({
    model: {
      state: null,
    },
    stateOptions: [],
    selectedState: [],
    showModal: false,
    acceptedTerms: false,
  }),
  computed: {
    isReadOnly() {
      return (
        this.statusId == providerProfileStates.Submitted ||
        this.statusId == providerProfileStates.Approved
      );
    },
    availablestateOptions() {
      return this.stateOptions.filter(
        (x) => !this.addedStateIds.includes(x.id)
      );
    },
    addedStateIds() {
      return this.selectedState.map((x) => x.id);
    },
    hasReasonsSelected() {
      return !this.selectedState?.length;
    },
  },
  props: {
    providerId: {
      type: Number,
      default: () => 0,
    },
    statusId: {
      type: Number,
      default: () => 0,
    },
    sectionTitle: {
      type: String,
      default: () => '',
    },
    options: {
      type: Array,
      default: () => [],
    },
    biddingAcademicYearId: {
      type: Number,
      default: () => 0,
    },
  },
  methods: {
    async onAddHandler() {
      const state = this.model.state;
      if (!state?.id) {
        this.ShowToast(
          'Alerta',
          'Favor seleccionar al menos un Municipio.',
          'error'
        );
      }

      this.isValid = await this.$refs.messageObserver.validate();
      if (this.isValid) {
        this.selectedState.push(state);
        this.$refs.messageObserver.reset();
        this.model.state = null;
      }
    },
    onDeleteItemHandler(index) {
      this.selectedState.splice(index, 1);
    },
    async getState() {
      this.stateOptions = (
        await _getStaticInformation()
      ).data.unitedStatesStateOptions;
    },
    async onCancel() {
      if (this.statusId != providerProfileStates.Denied) {
        const answer = await this.ShowCancelModal(
          'Confirmación',
          `¿Está seguro de que desea cancelar? Si cancela, se borrarán todos los datos que ha llenado en esta sección.`,
          'Sí',
          'No'
        );

        if (answer) {
          this.clean();
          this.$emit('on-cancel');
        } else {
          return;
        }
      } else {
        this.$emit('on-cancel');
      }
    },
    clean() {
      this.state = [];
      this.selectedState = [];
      this.showModal = false;
      this.acceptedTerms = false;
    },
    async onSubmit() {
      if (!this.acceptedTerms) {
        this.ShowToast(
          'Alerta',
          'Favor aceptar los términos y responsabilidades.',
          'error'
        );
        return;
      }

      const payload = {
        sectionId: providerQuestionSection.GeographicAreas,
        providerId: this.providerId,
        academicYearId: this.biddingAcademicYearId,
        statusId: providerProfileStates.Submitted,
        municipalities: this.addedStateIds,
      };

      const { data: response } = await _submitGeographicArea(payload);
      if (response) {
        this.ShowToast(
          'Confirmación',
          'El estatus ha sido actualizado exitosamente.',
          'success'
        );
        this.$emit('on-save');
      } else {
        this.ShowToast('Error', response?.data?.message || 'error', 'error');
      }

      this.showModal = false;
      this.acceptedTerms = false;
    },
    async onSaveHandler() {
      if (!this.hasReasonsSelected) {
        this.showModal = true;
      } else {
        this.ShowToast(
          'Alerta',
          'Favor seleccionar al menos un Municipio.',
          'error'
        );
        return;
      }
    },
    async onCancelAcceptTermHandler() {
      this.showModal = false;
      this.acceptedTerms = false;
    },
    async getMunicipality() {
      if (this.options != null) {
        this.selectedState.push(...this.options);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.reason-item {
  border-radius: 50px;
  border: 1px solid gainsboro;
  width: fit-content;
  font-size: 90%;
}
::v-deep .custom-icon {
  .dot {
    box-shadow: none !important;
    margin-right: 4px !important;
  }
  .dot.dot--has-border {
    border-color: transparent !important;
  }
  .color-gray-7.font-16.font-weight-bold {
    color: #11291b !important;
  }
}
</style>
